import React, { ReactElement } from 'react';
import { DI, DIProps } from '../../../../Core';
import Editproduct from '../../Editproduct/Editproduct';

interface Props extends DIProps { }

function EditVariant(props: Props): ReactElement {

    return (
        <>
            <Editproduct />
        </>
    );
}

export default DI(EditVariant);